<template>
  <div class="container-fluid mt--9">
    <div class="row">
      <div class="col">
        <div class="card shadow">
          <div class="card-header bg-transparent">
            <h3 class="mb-0">Pesquisa Avançada</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <p class="description font-weight-400">Pesquise por publicações
                      informando o texto ou parte do texto que você deseja encontrar. O intervalo entre duas datas e
                      opcional.</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <VueCtkDateTimePicker
                        :range="true"
                        :auto-close="true"
                        :no-weekends-days="true"
                        :no-button="true"
                        :custom-shortcuts="customShortcuts"
                        :max-date="maxDate"
                        label="Selecione a data (opcional)"
                        format="YYYY-MM-DD"
                        formatted="DD/MM/YYYY"
                        v-model="filtro.dia_data_publicacao"></VueCtkDateTimePicker>
                  </div>
                  <div class="col-5">
                    <base-input v-model="filtro.texto"
                                @keyup.enter.native="pesquisar('texto')"
                                placeholder="Informe o texto ou parte do texto que deseja encontrar">
                    </base-input>
                  </div>
                  <div class="col-3 text-center">
                    <p v-show="httpAction"><i class="fas fa-spinner fa-pulse"></i>
                      Pesquisando...</p>
                    <base-button v-show="!httpAction"
                                 :disabled="!filtro.texto || filtro.texto.length < 3"
                                 block icon="fas fa-search"
                                 @click="pesquisar()"
                                 type="default">Pesquisar
                    </base-button>
                  </div>
                </div>
                <div v-if="resultado && resultado.data" class="row">
                  <div v-if="resultado.data.length > 0" class="col-12">
                    <div class="list-group">
                      <div v-for="(item, index) in resultado.data" :key="index"
                           class="list-group-item flex-column align-items-start">
                        <div class="media">
                          <img @click="dowload(item, 'ONLINE')"
                               v-bind:src="baseUrl+'image/preview/'+item.dia_codigo+'_1.png'" class="mr-3"
                               style="cursor: pointer; width: 10%">
                          <div class="media-body">
                            <div class="d-flex w-100 justify-content-between">
                              <h3 class="mb-1">Diário Nº {{ item.dia_numero | padDigits }}</h3>
                              <small class="text-muted">{{ item.dia_downloads + ' downloads' }}</small>
                            </div>
                            <p class="mb-1">{{ item.dia_data_publicacao | dateExtensao }}</p>
                            <router-link target="_blank" ref="link" class="btn btn-outline-secondary btn-sm"
                                         :to="{name: 'diario', params: { dia_numero: item.dia_numero }}">
                              Diário em detalhe
                            </router-link>
                            <base-button outline type="secondary" @click="dowload(item)" size="sm">Baixar PDF
                            </base-button>
                            <base-button outline type="secondary" @click="dowload(item, 'HTML')" size="sm">Baixar HTML
                            </base-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="resultado.data.length < 1 && resultado.status" class="col-md-12">
                    Sua pesquisa <b>{{ ultimaPesquisa }}</b> não encontrou nenhuma edição correspondente.
                    <br>Sugestões:
                    <ul class="ml-4">
                      <li>Certifique-se de que todas as palavras estejam escritas corretamente.</li>
                      <li>Tente palavras-chave diferentes.</li>
                      <li>Tente palavras-chave mais genéricas.</li>
                      <li>Tente usar menos palavras-chave.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment-timezone'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import {getPesquisaAvancada} from '@/api/pesquisa';
import {dowloadDiario} from "@/plugins/webdom";
import {getBaseURL} from "@/config";

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
export default {
  name: "PesquisaAvancada",
  components: {},
  data() {
    return {
      maxDate: moment().format('YYYY-MM-DD HH:mm'),
      customShortcuts: [
        {key: 'thisWeek', label: 'Esta semana', value: 'isoWeek'},
        {key: 'lastWeek', label: '(-) Semana', value: '-isoWeek'},
        {key: 'last7Days', label: '(-) 7 dias', value: 7},
        {key: 'last30Days', label: '(-) 30 dias', value: 30},
        {key: 'thisMonth', label: 'Este mês', value: 'month'},
        {key: 'lastMonth', label: '(-) Mês', value: '-month'},
        {key: 'thisYear', label: 'Este ano', value: 'year'},
        {key: 'lastYear', label: '(-) Ano', value: '-year'}
      ],
      baseUrl: getBaseURL(),
      httpAction: false,
      ultimaPesquisa: '',
      filtro: {
        dia_data_publicacao: null,
        texto: '',
      },
      resultado: null,
    }
  },
  methods: {
    pesquisar() {
      this.httpAction = true;
      getPesquisaAvancada(this.filtro).then(response => {
        this.resultado = response;
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpAction = false;
        this.ultimaPesquisa = this.filtro.texto
      })
    },
    dowload(diario, tipo = 'PDF') {
      dowloadDiario(diario, tipo)
    },
  },
};
</script>
<style></style>
